import { ColumnDef, RowData } from '@tanstack/table-core';
import { useMemo } from 'react';

import { TableColumnDefinition, TableProps } from '../../types';

import getExpandColumnDef from './expandColumnDef';

function useColumns<TData extends RowData>(
  columns: TableColumnDefinition<TData>[],
  renderRowExpand: TableProps<TData>['renderRowExpand']
) {
  const formattedColumns = useMemo<ColumnDef<TData, unknown>[]>(() => {
    const baseColumns: ColumnDef<TData, unknown>[] = columns.map((column, index) => ({
      id: column.action ? String(index) : undefined,
      meta: {
        action: column.action,
      },
      accessorKey: column.path,
      header: column.name,
      footer: column.name,
      cell(context) {
        return typeof column.renderCell === 'function'
          ? column.renderCell(context)
          : context.getValue() || '';
      },
      enableSorting: column.sortable,
      size: column.size,
    }));

    if (renderRowExpand) {
      return [getExpandColumnDef<TData>(), ...baseColumns];
    }

    return baseColumns;
  }, [columns, renderRowExpand]);

  return formattedColumns;
}

export default useColumns;
